import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { APP_STYLES, AppStyle } from 'src/app/models/app-style.type';

@Injectable({
  providedIn: 'root',
})
export class AppStyleService {
  private router = inject(Router);

  /**
   * Retrieves the current `AppStyle` from the router's active route tree.
   *
   * This function traverses the router's snapshot starting from the root,
   * looking for the first route that defines `data.appStyle`. It validates
   * the value against the allowed `AppStyle` values (`'default' | 'ipt' | 'pp'`).
   *
   * If no `appStyle` is found, or the value is invalid, it returns `'default'`.
   *
   * @returns {AppStyle} The current application style.
   *   - `'default'` if no value is found or the value is invalid.
   */
  getAppStyle(): AppStyle {
    let snapshot: ActivatedRouteSnapshot | null =
      this.router.routerState.snapshot.root;

    while (snapshot) {
      const value = snapshot.data?.['appStyle'];
      if (value !== undefined) {
        if (APP_STYLES.includes(value as AppStyle)) {
          return value as AppStyle;
        } else {
          console.warn(
            `Invalid appStyle value "${value}" found in route data. Falling back to "default".`
          );
          return 'default';
        }
      }
      snapshot = snapshot.firstChild;
    }

    return 'default';
  }
}
